(function() {
  'use strict';

  function AutoSaveExitDirective() {
    return {
      scope: {
        info: '=',
        isDirty: '&'
      },
      restrict: 'AE',
      link: function(scope) {
        window.onbeforeunload = function(event) {
          if (scope.info.shouldSave) {
            var msg = 'Do you want to leave this page?';
            event.returnValue = msg;
            return msg;
          }
        };

        scope.$on('$destroy', function() {
          window.onbeforeunload = null;
        });
      }
    };
  }

  AutoSaveExitDirective.$inject = [];

  angular.module('component.drafts')
    .directive('kzAutoSaveExit', AutoSaveExitDirective);
})();
